import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './context'
import { baseUrl, apiUrl, client, custom_plan } from './delcare'
import UiSpinner from './ui_spinner';
import UiButton1 from './ui_button1';
import { useAuth0 } from "@auth0/auth0-react"

const Subscription = ({ register }) => {

    const { logout } = useAuth0()
    const {
        neonUser,
        getNeonUser,
        setToDeleteProfile,
        setPopupSidebarType,
        setSideBarTitle,
        offCanvas, hh,
        toUnsubscribe, setToUnsubscribe,
        reloadSubscription, setReloadSubscription,
        ww,
        updateChecklist,
        token,
        sliderRef,
        fetchDataV2
    } = useContext(AppContext)

    const navigate = useNavigate()

    const [products, setProducts] = useState([])
    const [range, setRange] = useState(0)
    const [subscribed, setSubscribed] = useState([])
    const [loaded, setLoaded] = useState(false)
    const [customSub, setCustomSub] = useState(null)
    const [rewardfulRef, setRewardfulRef] = useState("")

    const getProducts = async () => {
        let resp = await fetch(`${apiUrl}/stripe-products`, {
            method: "POST",
            headers: (() => {
                const myHeaders = new Headers()
                myHeaders.append("Content-Type", "application/json")
                myHeaders.append('Authorization', `Bearer ${token.accessToken}`)
                return myHeaders
            })()
        })
        resp = await resp.json()
        setProducts(resp.data.reverse())
    }

    const unauthorized = async (data) => {
        if (data.status >= 400 && data.status < 500) {
            window.localStorage.clear()
            logout({
                clientId: client,
                logoutParams: {
                    returnTo: window.location.origin
                }
            })
            return false
        }
        else return true
    }

    const createStripeCustomerId = async () => {
        let resp = await fetch(`${apiUrl}/stripe-customer`, {
            method: "POST",
            headers: (() => {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append('Authorization', `Bearer ${token.accessToken}`)
                return myHeaders
            })(),
            body: JSON.stringify(neonUser)
        })

        let authed = await unauthorized(resp)
        if (!authed) return;

        resp = await resp.text()
        initRewardful()
        getNeonUser()
        return
    }

    const getSubscription = async () => {
        setSubscribed([])

        let resp = await fetch(`${apiUrl}/stripe-get-subscription`, {
            method: "POST",
            headers: (() => {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append('Authorization', `Bearer ${token.accessToken}`);
                return myHeaders
            })(),
            body: JSON.stringify({ customer_id: neonUser.stripe_customer_id })
        })

        let authed = await unauthorized(resp)
        if (!authed) return;
        resp = await resp.json()

        if ("error" in resp) {
            setLoaded(true)
            return
        }

        for (let i = 0; i < resp.data.length; i++) {
            let x = resp.data[i]
            if (!("field" in x)) {
                let prod = await fetch(`${apiUrl}/stripe-get-product`, {
                    method: "POST",
                    headers: (() => {
                        const myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/json");
                        myHeaders.append('Authorization', `Bearer ${token.accessToken}`)
                        return myHeaders
                    })(),
                    body: (() => {
                        if (x.plan && "product" in x.plan) {
                            return JSON.stringify({ product_id: x.plan.product })
                        }
                        if (("items" in x) && x.items.data.length > 0) {
                            x.plan = x.items.data[0]
                            return JSON.stringify({ product_id: x.items.data[0].plan.product })
                        }
                        return JSON.stringify({ product_id: null })
                    })()
                })

                if (!prod.ok) return

                x.field = await prod.json()
            }
        }

        setSubscribed(resp.data)

        if (resp.data.length > 0) {
            updateChecklist('subscribe', neonUser.user_id)
            skipSubscription()
        }
        else {
            updateChecklist('subscribe', neonUser.user_id, true)
        }
        setLoaded(true)
    }

    const createSubscription = async () => {
        let user = neonUser

        let data = {
            url: `${baseUrl}/account/subscription`,
            price: products[range].default_price,
            customer_id: neonUser.stripe_customer_id,
            trial: user.agency.no_stripe_trial_offer
        }

        if (rewardfulRef) data.referral = rewardfulRef;

        let resp = await fetch(`${apiUrl}/stripe-subscription`, {
            method: "POST",
            headers: (() => {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append('Authorization', `Bearer ${token.accessToken}`)
                return myHeaders
            })(),
            body: JSON.stringify(data)
        })

        if (!resp.ok) return

        resp = await resp.text()

        try {
            resp = JSON.parse(resp)
        } catch (err) {
            return
        }

        if (!("url" in resp)) return

        window.location.href = resp.url;
        return
    }

    const cancelSubscription = async (x) => {
        setToUnsubscribe(x)
        setToDeleteProfile(x.id)
        setPopupSidebarType("unsubscribe")
        setSideBarTitle("Cancel Subscription")
        offCanvas.show()
        return
    }

    const showProductName = (x, field) => {
        let result = products.filter(xx => xx.id == x.plan.product)
        if (result.length == 0 && subscribed.length > 0) {
            return subscribed[0]['field'][field]
        }
        return result[0][field]
    }

    const viewPaymentHistory = async (e) => {
        e.preventDefault()

        let resp = await fetch(`${apiUrl}/stripe-view-payment`, {
            method: "POST",
            headers: (() => {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append('Authorization', `Bearer ${token.accessToken}`)
                return myHeaders
            })(),
            body: JSON.stringify({
                customer: neonUser.stripe_customer_id,
                return_url: baseUrl + "/account/subscription"
            })
        })

        if (!resp.ok) return

        resp = await resp.json()
        window.location.href = resp.url;
        return
    }

    const goBack = (e) => {
        e.preventDefault()
        skipSubscription()
        navigate("/account")
    }

    const skipSubscription = async (toDashboard) => {
        let query1 = "SKIP_SUBSCRIPTION", params1 = [neonUser.user_id]
        await fetchDataV2(query1, params1, "/neon-query-v2")
        if (toDashboard) navigate("/", { replace: true })
        return
    }

    const initRewardful = () => {
        if (neonUser && neonUser?.user?.email) {
            var url = new URL(window.location.href);
            var c = url.searchParams.get("rewardful");
            if (c == 1) {
                window.rewardful('ready', () => {
                    if (neonUser?.user?.role == "owner") {
                        window.rewardful('convert', { email: neonUser.user.email });
                        navigate("/account/subscription")
                    }
                })
            }
        }
    }

    useEffect(() => {
        if (products[range] && products[range].default_price) {
            setCustomSub(products[range].default_price)
        }
    }, [range])

    useEffect(() => {
        if (reloadSubscription) {
            setReloadSubscription(false)
            getSubscription()
        }
    }, [reloadSubscription])

    useEffect(() => {
        if (neonUser && neonUser.user_id && neonUser.stripe_customer_id == null) createStripeCustomerId()
        if (neonUser && neonUser.user_id) {
            getProducts()
            getSubscription()
            initRewardful()
        }
    }, [neonUser])

    useEffect(() => {
        window.rewardful('ready', () => {
            if (neonUser?.user?.role == "owner" && window.Rewardful.referral) {
                setRewardfulRef(window.Rewardful.referral)
            }
        })
    }, [])

    if (!loaded) return (
        <div className="d-flex justify-content-center" style={{ height: hh - (register ? 0 : 80) }}>
            <UiSpinner />
        </div>
    )

    return (
        <div className=''>
            <div className={register ? "login-bg" : ''}>
                <div className={"d-flex justify-content-center"} style={{ height: hh - (register ? 0 : 80) }}>
                    <div className={("mt-4 d-flex flex-column align-content-center p-2")}>
                        {register ?
                            <div className="d-flex justify-content-center mb-3">
                                <div className="bispoke-logo align-self-center"></div>
                            </div>
                            : null
                        }

                        <div className="login-container align-self-center" style={{ width: "clamp(100px, 450px, 100%)" }}>
                            <div className="d-flex" style={{ padding: `0px 0px 8px ${ww < 400 ? "15px" : "28px"}` }}>
                                {register && subscribed.length == 0 ?
                                    <i onClick={goBack} style={{ cursor: "pointer" }} className="bi bi-chevron-left fs-4 mt-1 align-self-center"></i>
                                    : null
                                }
                                <p className="fs-2 mb-0">Subscribe</p>
                            </div>

                            <div style={{ padding: `0px ${ww < 400 ? "15px" : "40px"}` }}>
                                <div style={{ height: 2 }} className="gradiant-h mb-4"></div>

                                {subscribed.length > 0 ?
                                    <>
                                        <div>
                                            <p className="poppins text-center">You have subscribed to the following plan:</p>
                                            <p className='text-center text-secondary mb-0'>Trailing 12 month revenue</p>
                                        </div>
                                        {subscribed.map(x => (
                                            <div key={x.id} className="text-center pb-3">
                                                <div className="lh-1 mb-4">
                                                    <p className="fs-5 text-secondary">{showProductName(x, 'name')}</p>
                                                    <span style={{ fontSize: 18 }} className="poppins fw-bold">{showProductName(x, 'description')}</span>
                                                </div>
                                                <div className="d-flex flex-column gap-3">
                                                    <UiButton1 text="Cancel Subscription" submit={() => cancelSubscription(x)} />
                                                    {register ? <span className='poppins text-secondary' style={{ cursor: "pointer" }} onClick={() => navigate("/")}>To Dashboard</span> : null}
                                                    <a className="text-secondary mb-1" href="#" onClick={viewPaymentHistory} style={{ textDecoration: "none", fontSize: 14 }}>
                                                        Update Payment Information
                                                    </a>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                    :
                                    <>
                                        <div className="text-center">
                                            <small className="poppins">
                                                Select a Subscription Plan based on your last 12 months of revenue using the slider:
                                            </small>
                                        </div>
                                        <div className="my-3">
                                            <input
                                                id="slider"
                                                ref={sliderRef}
                                                min={0} max={products.length - 1}
                                                value={range} onChange={e => setRange(e.target.value)}
                                                type="range" className="slider w-100" />
                                        </div>
                                        <div className="poppins text-center text-secondary mb-3">
                                            <p className='text-center text-secondary mb-0' style={{ fontSize: 14 }}>Trailing 12 month revenue</p>
                                            {products.length > 0 ?
                                                <p>
                                                    <span className='fw-bold fs-5 text-secondary'>{products[range].name}</span><br />
                                                    <span className='fw-bold fs-4 text-dark'>{products[range].description}</span>
                                                </p>
                                                :
                                                null
                                            }
                                        </div>
                                        <div className="text-center d-flex flex-column gap-3">
                                            {customSub == custom_plan ?
                                                <div
                                                    onClick={() => window.open("https://bispoke.io/contact-us/", "_blank")}
                                                    className='button3 d-flex flex-column justify-content-center' style={{ height: 44, cursor: "pointer" }}>
                                                    <span className='poppins' style={{ textDecoration: 'none', color: "#650260" }}>Contact Us</span>
                                                </div>
                                                :
                                                <UiButton1 text="Subscribe" submit={createSubscription} />
                                            }
                                            {register && subscribed.length == 0 ?
                                                <div className='d-flex flex-column gap-2'>
                                                    <a href="#" onClick={() => skipSubscription(true)}>Skip for now</a>
                                                </div>
                                                :
                                                <div className='text-center d-flex flex-column'>
                                                    <a className="text-secondary poppins" href="#" onClick={viewPaymentHistory} style={{ textDecoration: "none", fontSize: 14 }}>
                                                        Update Payment Information<br /><span className='fw-bold'>View Invoice History</span>
                                                    </a>
                                                </div>
                                            }
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Subscription